import { Inject, Injectable, forwardRef } from "@angular/core";
import { Thing } from "../model";
import { DatetimeFormatterPipe, LocalizationPipe } from "../shared/pipe";
import { CustomLabelPipe } from "../shared/pipe/custom-label.pipe";
import { AbstractExportContextService } from "./abstract-export-context.service";
import { AuthenticationService } from "./authentication.service";
import { FieldService } from "./field.service";

@Injectable()
export class TopBarExportContextService extends AbstractExportContextService {

    constructor(
        @Inject(forwardRef(() => AuthenticationService)) authenticationService: AuthenticationService,
        @Inject(forwardRef(() => DatetimeFormatterPipe)) datetimeFormatterPipe: DatetimeFormatterPipe,
        @Inject(forwardRef(() => FieldService)) fieldService: FieldService,
        @Inject(forwardRef(() => CustomLabelPipe)) customLabelPipe: CustomLabelPipe,
        @Inject(forwardRef(() => LocalizationPipe)) localizationPipe: LocalizationPipe
    ) {
        super(authenticationService, datetimeFormatterPipe, fieldService, customLabelPipe, localizationPipe);
    }

    isPdfExportAvailable(): boolean {
        return false;
    }

    getContextObject(): any {
        if (this.authenticationService.isLocationUser()) {
            return this.authenticationService.getUser().location;
        } else if (this.authenticationService.isCustomerUser()) {
            return this.authenticationService.getUser().customer;
        } else if (this.authenticationService.isPartnerUser()) {
            return this.authenticationService.getUser().partner;
        } else if (this.authenticationService.isOrganizationUser()) {
            return this.authenticationService.getUser().organization;
        }
        return null;
    }

    getCurrentThing(): Thing {
        return null;
    }
}